module.exports = __webpack_public_path__ + "assets/img/wgp.0f4c33a7.png";